import React, { useState, useCallback } from 'react';
import PropTypes from 'prop-types';
import { GENERIC_FILTER_PARAM_LOG_XML_CONTENT_QUERY } from '../../queries';
import { useQueryWithErrorHandling } from 'customHooks/errorHandling';
import GenericFilterParamLogXmlContentComponent from './GeneriFilterParamLogXmlContentComponent';

const GenericFilterParamLogXmlContentContainer = ({ id }) => {
  const [openPopUp, setOpenPopUp] = useState(false);

  const handlePopUp = useCallback(openPopUp => () => setOpenPopUp(!openPopUp), []);

  const { loading, data } = useQueryWithErrorHandling(GENERIC_FILTER_PARAM_LOG_XML_CONTENT_QUERY, {
    variables: { id },
    skip: !openPopUp
  });
  return <GenericFilterParamLogXmlContentComponent data={data} loading={loading} openPopUp={openPopUp} onPopUpChange={handlePopUp} />;
};

GenericFilterParamLogXmlContentContainer.propTypes = {
  id: PropTypes.number.isRequired
};

export default GenericFilterParamLogXmlContentContainer;
